<div class="display-value">{{ value }}</div>
@if (edited) {
    <cc-icon
        class="edited-icon"
        [icon]="'edit-pencil'"
        [size]="'small'"
        [flat]="true"
        [color]="'var(--edited-batch-edit-cell-icon-color)'"
    >
    </cc-icon>
}
